import React from "react";
import c from "classnames";
import moment from "moment";
// import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { ErrorBoundary } from "react-error-boundary";

import { usePost } from "../providers/content";
import { getLocation } from "../util/url";

import css from "./block.module.scss";

import theme from "../theme.js";

const FallbackImage = () => {
  return <img src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" className={c(css["image"])} />;
};

export const PreviewBlockWrapper = ({ style, href, className, image, placeholderColor, title, alt }) => {
  const wrapperClassName = c("d-block w-100 mt-4 bg-white mx-auto position-relative border", css["pb-wrapper"], className);

  const fallbackUrl = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";

  const inner = (
    <>
      {image ? (
        <div className={c(css["image-wrapper"])}>
          <ErrorBoundary FallbackComponent={FallbackImage}>
            <img
              src={
                (image["medium_large"] || image["medium"] || image["full"] || Object.values(image)[0] || { source_url: fallbackUrl })[
                  "source_url"
                ]
              }
              className={c(css["image"])}
              alt={alt}
            />
          </ErrorBoundary>
        </div>
      ) : (
        placeholderColor && <div className={c(css["image-wrapper"])} style={{ backgroundColor: placeholderColor }} />
      )}
      <div className="p-3 text-dark bg-white border-top w-100" style={{ transform: "translateY(-100%)", position: "absolute" }}>
        <p className="h5" style={{ height: "4.5rem", overflow: "hidden", textOverflow: "ellipsis" }}>
          {title}
        </p>
      </div>
    </>
  );

  if (href) {
    return (
      <a className={wrapperClassName} style={style} href={href}>
        {inner}
      </a>
    );
  }

  return (
    <div className={wrapperClassName} style={style}>
      {inner}
    </div>
  );
};

export const PreviewBlock = ({ id, slug, postType, onLoaded }) => {
  const [post] = usePost({ postType: postType || "post", id, slug });

  if (!post || !post.status || post.status !== "publish") {
    return (
      <PreviewBlockWrapper placeholderColor={theme["mebm-light-grey"]} title="" className="text-left">
        <Skeleton count={2} />
      </PreviewBlockWrapper>
    );
  }

  const title = postType === "tribe_events" ? post.title : post.title.rendered;
  const link = postType === "tribe_events" ? post.url : post.link;
  const image = postType == "tribe_events" ? post.image && { full: { source_url: post.image.url } } : post.image;

  if (onLoaded) {
    onLoaded();
  }

  return (
    <PreviewBlockWrapper
      image={image}
      placeholderColor={theme["mebm-light-grey"]}
      href={getLocation(link)}
      title={<span dangerouslySetInnerHTML={{ __html: title.trim() }} />}
      className={c("text-left ", `pb-wrapper-${postType}`)}
    />
  );
};

export const PreviewBlockSync = ({ post }) => {
  if (!post || !post.status || post.status !== "publish") {
    return (
      <PreviewBlockWrapper placeholderColor={theme["mebm-light-grey"]} title={<Skeleton />} className="text-left">
        <Skeleton count={2} />
      </PreviewBlockWrapper>
    );
  }

  return (
    <PreviewBlockWrapper
      image={{
        thumbnail: { source_url: post.image_thumbnail },
        medium: { source_url: post.image_medium },
        medium_large: { source_url: post.image_medium_large },
        full: { source_url: post.image_full },
      }}
      placeholderColor={theme["mebm-light-grey"]}
      href={post.link}
      title={<span dangerouslySetInnerHTML={{ __html: post.title }} />}
      className={c("text-left ", `pb-wrapper-${post.type}`)}
    />
  );
};
